import * as React from 'react';

const SvgFormRadioCheck = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" })
);

export { SvgFormRadioCheck as default };
//# sourceMappingURL=FormRadioCheck.es.js.map
